import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const TableTopBanners = () => {

  const servicesFaqData = [
    {
        question: "What are tabletop banners, and where can they be used?",
        answer: "Tabletop banners are compact, portable displays for events, trade shows, retail counters, and product launches. Printing of Table Top Banners is ideal for showcasing promotional messages or branding at eye level."
    },
    {
        question: "What is included in tabletop retractable banner printing?",
        answer: "Our Tabletop Retractable Banners printing includes lightweight, retractable mechanisms that allow quick setup and portability. These banners feature vibrant visuals and durable stands, perfect for compact spaces like counters or tables."
    },
    {
        question: "How do 3D-printed tabletop banners differ from traditional banners?",
        answer: "3D-printed tabletop banners offer unique, dimensional visuals that make displays more engaging and noticeable. They are ideal for businesses looking to stand out with creative and modern promotional tools."
    },
    {
        question: "Can Printingy handle bulk orders for custom tabletop banner printing?",
        answer: "Yes, Printingy specialises in custom tabletop banner printing for bulk orders. We ensure consistent quality, cost-effective solutions, and timely delivery for businesses, events, and campaigns."
    },
    {
        question: "What materials are used for tabletop banners?",
        answer: "We use durable, lightweight materials like high-quality vinyl and fabric for Table Top Banners printing. These materials ensure sharp graphics, long-term durability, and a professional look for compact displays."
    },
    {
        question: "What industries benefit from tabletop banners?",
        answer: "Industries such as retail, hospitality, education, and corporate sectors use the printing of Table Top Banners for product launches, informational displays, and event promotions."
    },
    {
        question: "How long does it take to print tabletop banners?",
        answer: "The turnaround time for custom tabletop banner printing depends on the order volume and design complexity. Bulk orders are typically completed within a few business days, with expedited services available for urgent needs."
    },
    {
        question: "Are tabletop banners easy to transport and set up?",
        answer: "Our Tabletop Retractable Banners printing solutions are designed for portability and quick setup. The lightweight stands and retractable mechanisms are ideal for frequent use at events or trade shows."
    },
    {
        question: "Do you offer design assistance for custom tabletop banners?",
        answer: "Absolutely. Printingy provides professional design support for design tabletop banner printing, ensuring that your banners feature eye-catching visuals, logos, and messaging that align with your branding."
    },
    {
        question: "What makes bulk tabletop banner printing cost-effective?",
        answer: "Bulk Table Top banner printing reduces per-unit costs, making it an economical solution for businesses needing multiple banners for promotions, events, or branding campaigns."
    }
  ];
  const [pageTitle, setPageTitle] = useState('Printing for Automotive');  // Dynamic title state

useEffect(() => {
  document.title = pageTitle; // Set the document title dynamically
}, [pageTitle]); // This will run whenever the pageTitle changes


  return (
    <div>
    <MetaManager 
  title="Custom Table Top Banners Printing Services"
  description="Professional printing of table top banners and tabletop retractable banners. Bulk custom tabletop banner printing and 3D tabletop banners for events and promotions."
  keywords="Printing of Table Top Banners,
Tabletop Retractable Banners Printing,
Table Top Banners Printing,
3D Printed Tabletop Banners,
Custom Tabletop Banner Printing
"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing of Table Top Banners</h1>
              <h2 className="text-muted">
              Custom tabletop banners and retractable banners for compact displays
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Tabletop banners are a versatile and compact solution for showcasing products, services, or messages at trade shows, conferences, and retail counters. Printingy specialises in printing Table Top Banners, delivering high-quality Tabletop Retractable Banners printing and custom tabletop banner printing for businesses.</p>
          <p>Our banners are designed for sharp visuals, portability, and durability, ensuring they leave a lasting impression. We also offer innovative 3D-printed tabletop banners for unique, eye-catching displays that stand out at any event.</p>
          <p>Perfect for promotional counters, presentations, or product launches, Printingy’s Tabletop Banner printing solutions guarantee cost-effective and professional results for bulk orders.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable and Custom Table Top Banner Printing Solutions</h2>
                <h3 className="large-hed">High-quality, durable, and portable banners for promotions</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert printing of Table Top Banners for compact, impactful displays.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk Tabletop Retractable Banner printing at competitive prices.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Unique 3D-printed tabletop banners for eye-catching visuals.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Fully tailored custom tabletop banner printing to meet branding needs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Lightweight, portable, and easy-to-set-up tabletop banners.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable materials with fade-resistant graphics for long-term use.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk and customised orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted solutions for events, retail counters, and corporate branding.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/tabletopbanners.jpg" // Path relative to the public folder
                  alt="High-quality tabletop retractable banner printing"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Table Top Banners Delivered On Time</h2>
            <h3 className="small-hed">Focus on your branding while we manage your tabletop banner printing needs</h3>
            <p>At Printingy, we provide premium-quality Tabletop Banner printing using advanced technology and durable materials. Whether you need Retractable Banners for events or unique 3D-printed tabletop banners for displays, we ensure sharp visuals and consistency across bulk orders.</p>
            <p>Our streamlined processes guarantee timely delivery and high-quality results, making us your trusted partner for all custom tabletop banner printing requirements.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default TableTopBanners;
